(() => {
  const ownScript = document.currentScript || document.querySelector('script[src*="wool-shade-card.js"]');
  if (!ownScript?.src) return;

  const assetUrl = (filename) => {
    const url = new URL(ownScript.src, window.location.origin);
    url.pathname = url.pathname.replace(/wool-shade-card\.js$/, filename);
    url.search = '';
    return url.toString();
  };

  const load = (filename) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  load('wool-shade-card-cart.js')
    .catch((error) => console.error('Wool shade cart controls could not load.', error))
    .finally(() => load('wool-shade-card-v2-base.js'));
})();
